import axios from 'axios';
import env from '../config/env';
import keycloak from '../config/keycloak';

export const API_URL = env.api.baseUrl;
export const API_BASE_PATH = env.api.basePath;

// Create a shared axios instance with common configuration
const api = axios.create({
  baseURL: `${API_URL}${API_BASE_PATH}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for adding the Keycloak token
api.interceptors.request.use(
  async (config) => {
    try {
      // Update token if it's expired
      if (keycloak.token) {
        await keycloak.updateToken(30); // Update token if it expires in 30 seconds
        config.headers['Authorization'] = `Bearer ${keycloak.token}`;
      }
      return config;
    } catch (error) {
      console.error('Failed to update Keycloak token:', error);
      keycloak.login(); // Redirect to login if token update fails
      return Promise.reject(error);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle common errors
api.interceptors.response.use(
  response => response,
  error => {
    // Handle 401 Unauthorized globally - redirect to Keycloak login
    if (error.response && error.response.status === 401) {
      keycloak.login();
    }

    // Note: Storage errors (503) are now handled locally in each component
    // They will display error messages in the UI where appropriate

    return Promise.reject(error);
  }
);

export default api;
